import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { MaintenanceService } from '../maintenance/maintenance.service';

export const maintenanceGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const maintenance = inject(MaintenanceService);
  const isMaintenancePage = state.url.split('?')[0] === '/maintenance';

  return maintenance.checkStatus().pipe(
    map((isMaintenance) => {
      if (isMaintenance) {
        return isMaintenancePage ? true : router.createUrlTree(['/maintenance']);
      }
      return isMaintenancePage ? router.createUrlTree(['/login']) : true;
    }),
  );
};
